"use client";

import { footerBlock } from '@/gql/graphql'
import { FooterCms, Sponsors } from '@nrldigitaltechnology/ui-community'
import { PartnerProps } from '@nrldigitaltechnology/ui-community/dist/components/Sponsors/types';
import React, { useEffect, useState } from 'react'
import { v4 as uuidv4 } from 'uuid';

type FooterLayoutProps = {
    res: footerBlock | null
    sponsorsCta?: any;
}

type Entity = {
    href: string;
    name: string;
    image?: string;
};

type EntityBlockSection = {
    header: string;
    entities: Entity[];
};

type FooterStateProps = {
    entityBlock: EntityBlockSection[],
    footerLinks: Entity[],
    socialLinks: Entity[],
    sponsorsBlock?: PartnerProps[],
    copyRightText?: string,
    copyRightLogo?: string
}

export const FooterLayout = ({ res, sponsorsCta }: FooterLayoutProps) => {

    const [sponsorsCtaState, setSponsorsCtaState] = useState<any>(null);

    const [footerState, setFooterState] = useState<FooterStateProps>({
        entityBlock: [],
        socialLinks: [],
        footerLinks: [],
        copyRightText: "",
        copyRightLogo: ""
    })

    useEffect(() => {
        if (sponsorsCta) {
            setSponsorsCtaState(sponsorsCta?.content?.items?.[0])
        }
    }, [sponsorsCta])


    function formateFooterOptions(footerData: any) {
        const footerNavBlocks: {
            href: string;
            name: string;
            image?: string;
            header?: string;
        }[] = []

        const socialBlocks: {
            href: string;
            name: string;
            image?: string;
            header?: string;
        }[] = []

        const footerNavLinks: Entity[] = [];
        const sponsorsNavBlocks: PartnerProps[] = []
        function recursion(objItem: any, name?: string) {
            if (Array.isArray(objItem)) {
                for (const el of objItem) {
                    recursion(el, name);
                }
            }
            else if (typeof objItem === 'object' && objItem !== null) {
                if (objItem.__typename === "GroupBlock") {

                    recursion(objItem.menuContentArea, objItem.name);
                } else if (objItem.__typename === "NavigationBlock") {
                    const obj = {
                        header: name || "",
                        name: objItem.name || "",
                        image: objItem.logo?.url?.default || "",
                        href: objItem.redirectionUrl?.default || ""
                    }
                    footerNavBlocks.push(obj);

                    // if (name === "Social Media") {
                    //     const obj = {
                    //         href: objItem.redirectionUrl?.default || "",
                    //         name: objItem.name || "",
                    //         image: objItem.logo?.url?.default || "",
                    //     }
                    //     socialBlocks.push(obj);
                    // } else {
                    //     const obj = {
                    //         header: name || "",
                    //         name: objItem.name || "",
                    //         image: objItem.logo?.url?.default || "",
                    //         href: objItem.redirectionUrl?.default || ""
                    //     }
                    //     footerNavBlocks.push(obj);
                    // }

                }
                else if (objItem.__typename === "SocialMediaBlock") {
                    const obj = {
                        href: objItem.url?.default || "",
                        name: objItem.sponsorName || "",
                        image: objItem.icon?.url?.default || "",
                    }
                    socialBlocks.push(obj);

                } else if (objItem.__typename === "MenuNavigation") {
                    const obj = {
                        name: objItem.title || "",
                        href: objItem.navigationLink?.default || ""
                    }
                    footerNavLinks.push(obj);
                }
                else if (objItem.__typename === "SponsorBlock") {

                    if (!sponsorsNavBlocks.some(item => item.title === name)) {
                        sponsorsNavBlocks.push({
                            id: `${name}_${uuidv4()}`,
                            title: name || "",
                            content: [{
                                id: `${objItem.sponsorName}_${uuidv4()}`,
                                partnerUrl: objItem?.sponsorUrl?.default,
                                logo: objItem?.logo?.url?.default
                            }]
                        })
                    } else {
                        sponsorsNavBlocks.find(item => item.title === name)?.content.push({
                            id: `${objItem.sponsorName}_${uuidv4()}`,
                            partnerUrl: objItem?.sponsorUrl?.default,
                            logo: objItem?.logo?.url?.default
                        })
                    }

                }
                else {
                    for (const key in objItem) {
                        recursion(objItem[key]);
                    }
                }
            }
        }
        recursion(footerData);


        setFooterState({
            ...footerState,

            entityBlock: entityBlockMapper(footerNavBlocks),
            socialLinks: socialBlocks,
            footerLinks: footerNavLinks,
            sponsorsBlock: sponsorsNavBlocks,
            copyRightText: res?.copyRightText || "",
            copyRightLogo: res?.copyRightLogo?.url?.default || ""

        })
    }

    useEffect(() => {
        if (!res)
            return;
        formateFooterOptions(res);
    }, [])

    function entityBlockMapper(data: any) {
        const finalArr: EntityBlockSection[] = []
        for (const item of data) {
            const foundHeader = finalArr?.find(i => i.header === item.header)
            if (foundHeader) {
                foundHeader.entities.push({
                    name: item.name,
                    image: item.image,
                    href: item.href
                })
            } else {
                finalArr.push({
                    header: item.header, entities: [{
                        name: item.name,
                        image: item.image,
                        href: item.href
                    }]
                })
            }
        }
        return finalArr
    }


    return (
        <>
            <div className="relative w-full flex justify-center">
                <div className="w-full max-w-[1440px]">
                    <div className="bottom-0 w-full pl-5">
                        <Sponsors
                            sponsorsData={footerState.sponsorsBlock || []}
                            sponsorCta={{ ctaLink: sponsorsCtaState?.ctaLink?.default || "", ctaText: sponsorsCtaState?.ctaText || "" }}
                        />
                    </div>
                </div>
            </div>
            <FooterCms
                socialHeader={res?.socialHeader || ""}
                socialLinks={footerState.socialLinks as { href: string, name: string, image: string }[]}
                entityBlock={footerState.entityBlock}
                footerLinks={footerState.footerLinks}
                copyrightText={footerState.copyRightText}
                copyrightLogo={footerState.copyRightLogo}
            />
        </>
    )
}